module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/multi-sample-bg-a158d2befd59e3ce7e08ab21bfd4b38f.png";